export default __webpack_public_path__ + "static/media/board-brown-white(reduced).acc23ecb.webp";